import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import '../TopExplore/../header/style.css';
import { Header } from ".";
import { AdminNavbar } from ".";
import { API_BASE_URL, ACCESS_TOKEN_NAME } from '../../../constants/apiConstants';

function TopExploreCreate() {
    const [participatingColleges, setParticipatingColleges] = useState("");
    const [examLobo, setExamLobo] = useState(null);
    const [status, setStatus] = useState("active");

    const navigate = useNavigate();

    const handleFileChange = (e) => {
        setExamLobo(e.target.files[0]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
      
        const formData = new FormData();
        // formData.append("role_id", "2"); // Adjust if needed
        // formData.append("user_id", "3"); // Adjust based on actual user context
        formData.append("title", participatingColleges);
        formData.append("status", status === "active" ? "1" : "0");
      
        if (examLobo) {
          formData.append("media_image_name", examLobo);
        }
      
        const headers = {
          "Authorization": `Bearer ${ACCESS_TOKEN_NAME()}`,
          // Do NOT add "Content-Type" manually for FormData
        };
      
        const requestOptions = {
          method: "POST",
          headers: headers,
          body: formData,
          redirect: "follow"
        };
      
        try {
          const response = await fetch(`${API_BASE_URL}/createExploreTopStudyPlaces/null`, requestOptions);
          const result = await response.json();
      
          if (response.ok) {
            console.log("Success:", result);
            navigate("/admin/topExploreList");
          } else {
            console.error("Server Error:", result);
          }
        } catch (error) {
          console.error("API Error:", error);
        }
      };
      

    return (
        <>
            <div>
                <Header />
                <div className="main-container">
                    <AdminNavbar />
                    <div className="main">
                        <div className="report-container">
                            <div className="report-header">
                                <h1 className="recent-Articles">Create Explore Top Study Places</h1>
                            </div>
                            <div className="report-body">
                                <div className="user-form">
                                    <form onSubmit={handleSubmit} encType="multipart/form-data">
                                        <div className="mb-3">
                                            <label htmlFor="participating_colleges" className="form-label">Name</label>
                                            <input 
                                                type="text" 
                                                className="form-control"
                                                id="participating_colleges" 
                                                name="participating_colleges" 
                                                value={participatingColleges} 
                                                onChange={(e) => setParticipatingColleges(e.target.value)}
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label htmlFor="exam_lobo" className="form-label">Lobo (Upload Image)</label>
                                            <input 
                                                type="file" 
                                                className="form-control"
                                                id="exam_lobo" 
                                                name="exam_lobo" 
                                                accept="image/*"
                                                onChange={handleFileChange}
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label htmlFor="status" className="form-label">Status</label>
                                            <select 
                                                id="status" 
                                                className="form-control" 
                                                value={status}
                                                onChange={(e) => setStatus(e.target.value)}
                                            >
                                                <option value="active">Active</option>
                                                <option value="inactive">Inactive</option>
                                            </select>
                                        </div>

                                        <button type="submit" className="btn btn-primary submit-btn">
                                            CREATE
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default TopExploreCreate;
